var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var SchoolSearch = require("components/org/roster/SchoolSearch");
var Glyphicon = require("components/utility/icons/Glyphicon");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var DisplayToggleControl = require("components/utility/DisplayToggleControl");
import ReactSelect from "react-select";

import { Link } from "react-router-dom";


class CleverLinkSchoolOrgs extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { 
			currentStep: "district-school-orgs",
			canonicalDistrict: null, 
			schoolOrgs: [], // SCHOOL ORGS ATTACHED TO DISTRICT ORGS
			selectedSchoolOrgs: {}, // SELECTEDSCHOOL ORGS ATTACHED TO DISTRICT ORGS
			selectedCanonicalSchools: {}, // CANONICAL SCHOOLS
			schoolsWithCanonicalId: {}, // SCHOOLS WITH CANONICAL ID
			selectedSchoolsWithCanonicalId: {}, // SELECT SCHOOL WITH CANONICAL ID
			selectedSchoolOrgsWithCanonicalId: {} } // SELECT SCHOOL ORG WITH SCHOOL WITH CANONICAL ID
	}
	
	getPendingSchools() {
		return _.values(_.pick(this.props.schools, (school) => {
			return !school.school_org_id 
		}))
	}

	getLinkedSchools() {
		return _.values(_.pick(this.props.schools, (school) => {
			return school.school_org_id 
		}))
	}

	getProvisionableSchools() {
		return _.values(_.pick(this.getPendingSchools(), (school) => {
			return (school.clever_id in this.state.selectedSchoolOrgs) ||
			 (school.clever_id in this.state.selectedSchoolOrgsWithCanonicalId) ||
			 (school.clever_id in this.state.selectedSchoolsWithCanonicalId)
		}))
	}

	onSelectedSchoolOrg(school, selected) {
		var selectedSchoolOrgs = this.state.selectedSchoolOrgs
		if (selected) {
			selectedSchoolOrgs[school.clever_id] = selected
		} else {
			delete school.clever_id in selectedSchoolOrgs
		}
		
		this.setState({ selectedSchoolOrgs })
	}

	renderSchoolOrgSearchOptions(school) {
		var options = _.map(this.state.schoolOrgs, (schoolOrg) => {
			return {value: schoolOrg, label: schoolOrg.name}
		})
		return <ReactSelect name="school-org" value={ this.state.selectedSchoolOrgs[school.clever_id] }
						options={ options } onChange={ this.onSelectedSchoolOrg.bind(this, school) } />
	}

	renderLinkWithDistrictOrgSchool() {
		var schoolRows = _.map(this.getPendingSchools(), (school, s) => {
			return (
				<tr key={s}>
					<td>
						{ school.name }
					</td>
					<td>
						{ this.renderSchoolOrgSearchOptions(school) }
					</td>
				</tr>
			)
		})
		return (
			<div>
				<p>
					The preffered matching method!
				</p>
				<table className="table">
					<thead>
						<tr>
							<th>
								School Name
							</th>
							<th>
								Link with district schools
							</th>
						</tr>
					</thead>
					<tbody>
						{ schoolRows }
					</tbody>
				</table>
			</div>
		)
	}
	
	selectCanonicalSchool(school, selected) {
		var selectedCanonicalSchools = this.state.selectedCanonicalSchools
		if (selected) {
			selectedCanonicalSchools[school.clever_id] = selected
			this.fetchSchoolsWithCanonicalId(school, selected.value.id)
		} else {
			delete selectedCanonicalSchools[school.clever_id]
		}
		
		this.setState({ selectedCanonicalSchools })
		
	}

	onSelectedSchoolWithCanonicalID(school, selected) {
		var selectedSchoolsWithCanonicalId = this.state.selectedSchoolsWithCanonicalId
		if (selected) {
			selectedSchoolsWithCanonicalId[school.clever_id] = selected	
		} else {
			delete selectedSchoolsWithCanonicalId[school.clever_id]
		}
		this.setState({ selectedSchoolsWithCanonicalId })
	}

	renderDistrictSchoolOptions(school) {
		var options = _.map(this.state.canonicalDistrict.schools, (school) => {
			return {value: school, label: school.name}
		})
		return <ReactSelect name="school" value={ this.state.selectedCanonicalSchools[school.clever_id] }
						options={ options } onChange={ this.selectCanonicalSchool.bind(this, school) } />
	}

	renderCanonicalSchoolOptions(school) {
		var options = _.map(this.state.schoolsWithCanonicalId[school.clever_id], (school) => {
			return {value: school, label: school.name + " :" + school.l2e_id + " (" + school.school_org_count + ")"}
		})
		return <ReactSelect name="school" value={ this.state.selectedSchoolsWithCanonicalId[school.clever_id] }
						options={ options } onChange={ this.onSelectedSchoolWithCanonicalID.bind(this, school) } />
	}

	onSelectedSchoolOrgWithCanonicalID(school, selected) {
		var selectedSchoolOrgsWithCanonicalId = this.state.selectedSchoolOrgsWithCanonicalId
		if (selected) {
			selectedSchoolOrgsWithCanonicalId[school.clever_id] = selected
		} else {
			delete selectedSchoolOrgsWithCanonicalId[school.clever_id]
		}
		
		this.setState({ selectedSchoolOrgsWithCanonicalId })
	}

	renderCanonicalSchoolOrgOptions(school) {
		const school_ = this.state.selectedSchoolsWithCanonicalId[school.clever_id].value

		var options = _.map(school_.school_orgs, (schoolOrg) => {
			return {value: schoolOrg, label: schoolOrg.name}
		})
		console.log("SCHOOL ORG OPTIONS", options, school_)
		return <ReactSelect name="school-org" value={ this.state.selectedSchoolOrgsWithCanonicalId[school.clever_id] }
						options={ options } onChange={ this.onSelectedSchoolOrgWithCanonicalID.bind(this, school) } />
	}
	
	renderLinkWithCanonicalSearch() {
		var schools = this.getPendingSchools()
		schools = _.values(_.pick(schools, (school) => !(school.clever_id in this.state.selectedSchoolOrgs)))

		var schoolRows = _.map(schools, (school, s) => {

			var schoolOptions = "No results"
			var districtSchoolOptions = "No options"

			if (this.state.canonicalDistrict && this.state.canonicalDistrict.schools.length > 0) {
				var districtSchoolOptions = this.renderDistrictSchoolOptions(school)
			}
			if (school.clever_id in this.state.selectedCanonicalSchools) {
				if (school.clever_id in this.state.schoolsWithCanonicalId) {
					if (this.state.schoolsWithCanonicalId[school.clever_id].length > 0) {
						schoolOptions = this.renderCanonicalSchoolOptions(school)

						if (school.clever_id in this.state.selectedSchoolsWithCanonicalId) {
							var schoolOrgOptions = this.renderCanonicalSchoolOrgOptions(school)
							console.log("OPTIONS", schoolOrgOptions)
						}
					} else {
						schoolOptions = (
							<button className="btn btn-default" onClick={this.createSchool.bind(this, school)}>
								Create school
							</button>
						)
					}
				} else {
					var schoolOptions = <Spinner placeholder={ true } scale={ 0.5 } />
				}
			}

			return (
				<tr key={s}>
					<td>
						{ school.name }
					</td>
					<td>
						{ districtSchoolOptions }
					</td>
					<td>
						<SchoolSearch ref="search" 
							onSelect={ this.selectCanonicalSchool.bind(this, school) } 
							selectedSchool={ this.state.selectedCanonicalSchools[school.clever_id] } />
					</td>
					<td>
						{ schoolOptions }
					</td>
					<td>
						{ schoolOrgOptions }
					</td>
				</tr>
			)
		})
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							School Name
						</th>
						<th>
							District Schools
						</th>
						<th>
							Canonical Search
						</th>
						<th>
							School
						</th>
						<th>
							School Org
						</th>
					</tr>
				</thead>
				<tbody>
					{ schoolRows }
				</tbody>
			</table>
		)
	}
	renderExplanation(explanation, cleverSchool, selected) {
		console.log("Explanation", cleverSchool, selected)
		if (explanation == "district_org_link" || explanation == "canonical_school_org_link") {
			var text = "#This will attach the selected school org with the CleverSchool: \r\nclever_school = CleverSchool.find_by(clever_id: \""+cleverSchool.clever_id+"\")\r\nclever_school.school_org_id == "+ selected.id+"\r\nclever_school.clever_district.district_org_id == clever_school.school_org.district_org.id"
		} else if (explanation == "new_school_org") {
			var text = "#This will create a new school org with the following canonical id: \r\nclever_school = CleverSchool.find_by(clever_id: \""+cleverSchool.clever_id+"\")\r\school_org = SchoolOrg.find(?)\r\school_org.school.canonical_id == "+ selected.canonical_id+"\r\nclever_school.school_org_id == school_org.id\r\nclever_school.clever_district.district_org_id == clever_school.school_org.district_org.id"
		} else if (explanation == "provisioned") {
			var text = "clever_school = CleverSchool.find_by(clever_id: \""+cleverSchool.clever_id+"\")\r\nclever_school.school_org_id == "+ selected+"\r\nclever_school.clever_district.district_org_id == clever_school.school_org.district_org.id"
		} else {
			var text = "A canonical school is needed to link the cleverSchool with an existing or new school org"
		}

		return (
			<textArea className="form-control" disabled="true" rows={7}>
				{ text }
			</textArea>
		)
	}

	renderProvisionList() {
		var schoolRows = _.map(this.getPendingSchools(), (school, s) => {
			if (school.clever_id in this.state.selectedSchoolOrgs) {
				var selected = this.state.selectedSchoolOrgs[school.clever_id].value
				var action = (
					<button className="btn btn-primary" onClick={this.linkSchoolOrg.bind(this, school)}>
						Link via District Org
					</button>
				)
				var explanation = "district_org_link"
			} else if (school.clever_id in this.state.selectedSchoolOrgsWithCanonicalId) {
				var selected = this.state.selectedSchoolOrgsWithCanonicalId[school.clever_id].value
				var action = (
					<button className="btn btn-primary" onClick={this.linkCanonicalSchoolOrg.bind(this, school)}>
						Link via Canonical schools
					</button>
				)
				var explanation = "canonical_school_org_link"
			} else if (school.clever_id in this.state.selectedSchoolsWithCanonicalId) {
				var selected = this.state.selectedSchoolsWithCanonicalId[school.clever_id].value
				var action = (
					<button className="btn btn-default" onClick={this.createSchoolOrg.bind(this, school)}>
						Create new School Org
					</button>
				)
				var explanation = "new_school_org"
			} else {
				var selected = "Missing School and School Org"
				var action = "Action required: create school"
			}

			return (
				<tr key={s}>
					<td>
						{ school.name }
					</td>
					<td>
						{ selected.id } | { selected.name }
					</td>
					<td>
						{ action }
					</td>
					<td>
						{ this.renderExplanation(explanation, school, selected) }
					</td>
				</tr>
			)
		})

		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							School Name
						</th>
						<th>
							School Org ID
						</th>
						<th>
							Action
						</th>
						<th>
							Explanation
						</th>
					</tr>
				</thead>
				<tbody>
					{ schoolRows }
				</tbody>
			</table>
		)
	}

	renderProvisionedSchools() {
		var schoolRows = _.map(this.getLinkedSchools(), (school, s) => {
			return (
				<tr key={s}>
					<td>
						{ school.name } | { school.id }
					</td>
					<td>
						{ school.school_org_id }
					</td>
					<td>
						{ this.renderExplanation("provisioned", school, school.school_org_id ) }
					</td>
				</tr>
			)
		})
		return (
			<table className="table">
				<thead>
					<tr>
						<th>
							Linked Clever Schools
						</th>
						<th>
							School Org ID
						</th>
						<th>
							Console Test
						</th>
					</tr>
				</thead>
				<tbody>
					{ schoolRows }
				</tbody>
			</table>
		)	
	}

	renderView() {

		if (this.state.schoolOrgs.length > 0 && this.state.currentStep == "district-school-orgs") {
			var linkWithDistrictOrgSchools = this.renderLinkWithDistrictOrgSchool()
		}

		if (this.state.currentStep == "canonical-search") {
			var linkWithCanonicalSearch = this.renderLinkWithCanonicalSearch()
		}

		if (this.state.currentStep == "provisioning") {
			var provisionList = this.renderProvisionList()
		}

		return (
			<div>
				{ this.renderOption() }
				{ linkWithDistrictOrgSchools }
				{ linkWithCanonicalSearch }
				{ provisionList }
				{ this.renderProvisionedSchools() }
			</div>
		)
	}

	onViewChange(select) {
		this.setState({currentStep: select})
	}

	renderOption() {
		var linkedSchools = this.getProvisionableSchools()

		if (this.state.schoolOrgs.length > 0) {
			var toggleOptions = [
				{ key: "district-school-orgs", text: "Link Distrit School Orgs" }, 
				{ key: "canonical-search", text: "Search Canonical Schools" },
			];
		} else {
			var toggleOptions = [
				{ key: "canonical-search", text: "Search Canonical Schools" },
			];
		}
		toggleOptions.push({ key: "provisioning", text: "Provision School Orgs ("+linkedSchools.length + ")" })

		return (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ this.onViewChange }
				activeOptionKey={ this.state.currentStep } />
		);
	}

	render() {
		var view = this.renderView()

		return (
			<div className="CleverLinkSchoolOrgs">
				{ view }
			</div>
		);
	}

	componentDidMount() {
		this.getCanonicalDistrict()
		this.fetchDistrictSchoolOrgs()
	}

	getCanonicalDistrict(input, callback) {
		var params = { embed: "district.schools" };
		var canonicalId = this.props.accessToken.district_org.canonical_id
		if (canonicalId) {
			var url = WhooosReadingServices.CanonicalSchools.url("/districts/"+canonicalId, params);

			$.getJSON(url, function(data) {
				console.log(data)
				this.setState({canonicalDistrict: data.district})
			}.bind(this));
		}
	}

	fetchDistrictSchoolOrgs() {
		CurrentUser.api().getDistrictOrg(this.props.accessToken.district.district_org_id, {embed: "district_org.school_orgs"} , $wr.apiHandler((response) => {
			if (response.district_org.school_orgs.length > 0) {
				var currentStep = "district-school-orgs"
			} else {
				var currentStep = "canonical-search"
			}
			this.setState({schoolOrgs: response.district_org.school_orgs, currentStep})
		}));
	}

	fetchSchoolsWithCanonicalId(school, canonicalId) {
		CurrentUser.api().getSchools({canonical_id: canonicalId, embed: "school.school_orgs,school.school_org_count"} , $wr.apiHandler((response) => {
			var schoolsWithCanonicalId = this.state.schoolsWithCanonicalId
			schoolsWithCanonicalId[school.clever_id] = response.schools
			this.setState({schoolsWithCanonicalId})
		}));
	}

	// LINK AND CREATION FUNCTIONS
	linkSchoolOrg(school) {
		// SCHOOL ORG LISTED UNDER THE LINKED DISTRICT ORG
		const schoolOrg = this.state.selectedSchoolOrgs[school.clever_id].value

		CurrentUser.api().patchSchoolOrg(schoolOrg.id, {clever_school_id: school.clever_id}, $wr.apiHandler((response) => {
			this.props.onSchoolUptate(school, schoolOrg)
			this.forceUpdate()
		}));
	}

	linkCanonicalSchoolOrg(school) {
		// SCHOOL ORG RELATED TO THE SELECTED CANONICAL SCHOOL
		const schoolOrg = this.state.selectedSchoolOrgsWithCanonicalId[school.clever_id].value

		CurrentUser.api().patchSchoolOrg(schoolOrg.id, {clever_school_id: school.clever_id}, $wr.apiHandler((response) => {
			this.props.onSchoolUptate(school, schoolOrg)
			this.forceUpdate()
		}));
	}

	createSchool(school) {
		var selCanSchool = this.state.selectedCanonicalSchools[school.clever_id]
		console.log(selCanSchool, this.props.accessToken)

		var school_data = {}
		school_data["name"] = school.name
		school_data["type"] = "other public"
		school_data["zip"] = selCanSchool.value.zip
		school_data["district_id"] = this.state.canonicalDistrict.id
		school_data["district"] = this.state.canonicalDistrict.name
		school_data["district"] = this.state.canonicalDistrict.name
		school_data["canonical_id"] = selCanSchool.value.id

		CurrentUser.api().patchCleverAccessToken(this.props.accessToken.id, {school: school_data}, $wr.apiHandler((response) => {
			this.state.schoolsWithCanonicalId[school.clever_id] = [response.school]
			this.setState({ schoolsWithCanonicalId: this.state.schoolsWithCanonicalId });
		}));
	}

	createSchoolOrg(school) {
		// CANONICAL SCHOOL SELECTED BUT DOESN'T HAVE SCHOOL ORGS
		const canonicalSchool = this.state.selectedSchoolsWithCanonicalId[school.clever_id].value

		var schoolOrg = {
			school_id: canonicalSchool.l2e_id
		}
		CurrentUser.api().postSchoolOrgs({school_org: schoolOrg, clever_school_id: school.clever_id}, $wr.apiHandler((response) => {
			this.props.onSchoolUptate(school, response.school_org)
			this.forceUpdate()
		}));
	}
};

CleverLinkSchoolOrgs.propTypes = PageStrictPropTypes({
});

module.exports = CleverLinkSchoolOrgs;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/CleverLinkSchoolOrgs.js